import { ActionsColumn, TABLE_ACTION, TABLE_ACTION_STATE } from '@qrios/frontend-library';

import { AirtimeBillingResponseItem, AirtimeBillingTableData, AirtimeBillingTableRowActions } from './interfaces';

export const mapApiDataIntoTableFormat = (
  data: AirtimeBillingResponseItem[],
  actions: AirtimeBillingTableRowActions
): AirtimeBillingTableData[] =>
  data.map((airtimeAndDataBillingItem: AirtimeBillingResponseItem) => {
    const { cost, amount, id, ...rest } = airtimeAndDataBillingItem;

    const actionsProp = [
      {
        name: TABLE_ACTION.INFO,
        state: TABLE_ACTION_STATE.ACTIVE,
        handler: () => {
          actions.openDetails(id);
        }
      }
    ];

    return {
      ...rest,
      id,
      cost: cost.value,
      amount: amount.value,
      actions: <ActionsColumn actions={actionsProp} />
    };
  });
